import React, { useRef } from "react";
import { AGTable } from "@/components";
import { EntityTableProps } from "./EntityTable.types";
import { useEntityTable } from "./hooks/useEntityTable";

/**
 * EntityTable component
 * Displays portfolios in master-detail AG Grid with lazy-loaded accounts
 */
export const EntityTable: React.FC<EntityTableProps> = ({
    dataMap,
    loading,
    onRowExpand,
    onEditPortfolio,
    onDeletePortfolio,
    onViewAccountDetails,
    onDeleteAccount,
}) => {
    const gridRef = useRef();

    const { colDefs, defaultColDef, getContextMenuItems, detailCellRendererParams } =
        useEntityTable({
            onRowExpand,
            onEditPortfolio,
            onDeletePortfolio,
            onViewAccountDetails,
            onDeleteAccount,
            loading,
        });

    const rowData = Array.from(dataMap.values());

    return (
        <AGTable
            gridRef={gridRef}
            rowData={rowData}
            colDefs={colDefs}
            defaultColDef={defaultColDef}
            groupDisplayType="singleColumn"
            sideBar={false}
            animateRows
            getContextMenuItems={getContextMenuItems}
            masterDetail
            detailCellRendererParams={detailCellRendererParams}
            tableHeight={500}
        />
    );
};
